import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import logo from "../../../image/LogoNavvayu.png";
 
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import api from "../../../api/api";
 
const ResetPassword = () => {
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(window.location.search);
  const token = queryParams.get("token");
 
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [successMsg, setSuccessMsg] = useState(""); // <-- Success message state
  const [errorMsg, setErrorMsg] = useState(""); // Optional: to show API error
 
  const initialValues = {
    newPassword: "",
    confirmPassword: "",
  };
 
  const validationSchema = Yup.object({
    newPassword: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .required("New password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
      .required("Confirm password is required"),
  });
 
  const onSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const response = await api.post(`/auth/reset-password?token=${token}`, {
        newPassword: values.newPassword,
        confirmPassword: values.confirmPassword,
      });
 
      setSuccessMsg(response.data.message || "Password reset successful!");
      setErrorMsg("");
      resetForm();
 
      // Optional: auto redirect after 2-3 seconds
      setTimeout(() => navigate("/login"), 3000);
    } catch (error) {
      console.error("Reset Password Error:", error);
      setErrorMsg(
        error.response?.data?.message ||
          "Something went wrong. Please try again."
      );
      setSuccessMsg("");
    } finally {
      setSubmitting(false);
    }
  };
 
  return (
    <div className="auth-container d-flex justify-content-center align-items-center">
      <div
        className="card auth-card shadow"
        style={{ maxWidth: 550, width: "100%" }}
      >
        <div className="card-body">
          <img
            src={logo}
            alt="Logo"
            className="auth-logo mb-4"
            style={{ width: "100%" }}
          />
 
          {/* Success Message */}
          {successMsg && (
            <div className="alert alert-success">{successMsg}</div>
          )}
          {/* Error Message */}
          {errorMsg && <div className="alert alert-danger">{errorMsg}</div>}
 
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ isSubmitting }) => (
              <Form>
                <div className="mb-3">
                  <h6 className="auth">
                    Enter and confirm your new password below.
                  </h6>
 
                  <div className="position-relative">
                    <label
                      className="form-label required"
                      htmlFor="newPassword"
                    >
                      New Password
                    </label>
                    <Field
                      type={showPassword ? "text" : "password"}
                      name="newPassword"
                      className="form-control"
                      placeholder="Enter new password"
                    />
                    <span
                      onClick={() => setShowPassword(!showPassword)}
                      className="inputicon"
                    >
                      {showPassword ? (
                        <VisibilityOffIcon />
                      ) : (
                        <VisibilityIcon />
                      )}
                    </span>
                  </div>
                  <ErrorMessage
                    name="newPassword"
                    component="div"
                    className="invalid-feedback d-block"
                  />
                </div>
 
                <div className="mb-3 position-relative">
                  <label
                    className="form-label required"
                    htmlFor="confirmPassword"
                  >
                    Confirm Password
                  </label>
                  <div className="position-relative">
                    <Field
                      type={showConfirmPassword ? "text" : "password"}
                      name="confirmPassword"
                      className="form-control"
                      placeholder="Confirm new password"
                    />
                    <span
                      onClick={() =>
                        setShowConfirmPassword(!showConfirmPassword)
                      }
                      className="inputicon"
                    >
                      {showConfirmPassword ? (
                        <VisibilityOffIcon />
                      ) : (
                        <VisibilityIcon />
                      )}
                    </span>
                  </div>
                  <ErrorMessage
                    name="confirmPassword"
                    component="div"
                    className="invalid-feedback d-block"
                  />
                </div>
 
                {/* Submit Button */}
                <button
                  type="submit"
                  className="btn btn-primary w-100 mt-2"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Resetting Password..." : "Reset Password"}
                </button>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};
export default ResetPassword;